
// export const appStats = (state) => state.appStats.stats
// export const appStats = (state) => state.appStats.list.items
export const appStats = (state, props) => state.appStats.statsByAppId[props.match.params.appId] || {}
export const loadingAppStats = (state) => state.appStats.isLoading

export const totals = (state, props) => state.appStats.totalsByAppId
